import { App, Button, Flex, Input, Space } from 'antd';
import React, { useState } from 'react';
import useFormInstance from 'antd/es/form/hooks/useFormInstance';
import OrderFormItem from '../../components/OrderFormItem';
import { STEPS } from '../constants';
import Steps from '../Steps';
import Adjustment from './Adjustment';
import CustomDeliveryFee from './CustomDeliveryFee';
import KitchenTip from './KitchenTip';
import Tip from './Tip';
import { getHttpErrorMessage } from 'utils/http';
import { captureException } from 'utils/errors';

function CouponInput({ value, onChange, onApply, applying }) {
  return (
    <Space.Compact style={{ display: 'flex' }}>
      <Input
        placeholder="Enter coupon code"
        allowClear
        value={value}
        onChange={(e) => onChange(e.target.value)}
        style={{ flex: 1 }}
      />
      <Button
        type="primary"
        htmlType="button"
        onClick={onApply}
        loading={applying}
        style={{ minWidth: 80 }}
      >
        Apply
      </Button>
    </Space.Compact>
  );
}

function AdditionalDetails({ onValidateCoupon }) {
  const [applying, setApplying] = useState(false);
  const form = useFormInstance();
  const { message } = App.useApp();

  const handleApplyCoupon = async () => {
    if (!onValidateCoupon) return;
    const couponCode = (form.getFieldValue('coupon_code') || '').trim();
    if (!couponCode) {
      message.warning('Please enter a coupon code first.');
      return;
    }
    setApplying(true);
    try {
      const result = await onValidateCoupon();
      if (result?.success) {
        const amount = result.couponAmount;
        if (amount && Number(amount) > 0) {
          message.success(`Coupon applied! Discount: $${Number(amount).toFixed(2)}`);
        } else {
          message.success('Coupon applied. Discount will be shown in order summary.');
        }
      } else {
        message.error(result?.error || 'Could not validate coupon.');
      }
    } catch (e) {
      captureException(e);
      const errMsg = getHttpErrorMessage(e) || e?.message || 'Could not validate coupon.';
      message.error(errMsg);
    } finally {
      setApplying(false);
    }
  };

  return (
    <Steps.Step step={STEPS.ADDITIONAL_DETAILS}>
      <Flex vertical gap={24}>
        <Adjustment />
        <CustomDeliveryFee />
        <Tip />
        <KitchenTip />

        <OrderFormItem label="Delivery notes" name="delivery_message" labelColStyle={{ width: 300 }}>
          <Input.TextArea
            placeholder="Delivery notes"
            showCount
            multiple
            maxLength={100}
            rows={4}
          />
        </OrderFormItem>

        <OrderFormItem label="Coupon code" name="coupon_code" labelColStyle={{ width: 300 }}>
          <CouponInput onApply={handleApplyCoupon} applying={applying} />
        </OrderFormItem>
      </Flex>
    </Steps.Step>
  );
}
export default AdditionalDetails;
